import { render, staticRenderFns } from "./UserSearchItemSkeleton.vue?vue&type=template&id=d64590b6&scoped=true"
import script from "./UserSearchItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./UserSearchItemSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchItemSkeleton.vue?vue&type=style&index=0&id=d64590b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64590b6",
  null
  
)

export default component.exports